import { apiClient } from './_shared.js'

export async function getPvzByInviteCode(inviteCode) {
  try {
    const data = await apiClient(`/pvz/by-invite/${inviteCode}`)
    if (!data) return null
    return {
      id: data.id,
      name: data.name,
      org_id: data.org_id
    }
  } catch(e) {
    return null
  }
}

// ============================================
// INVITES
// ============================================

export async function getInvites(pvzId) {
  return await apiClient(`/invites/${pvzId}`)
}

export async function createInvite(pvzId, orgId) {
  return await apiClient('/invites', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, org_id: orgId })
  })
}

export async function deleteInvite(id) {
  await apiClient(`/invites/${id}`, { method: 'DELETE' })
}
